// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mi-0";
export var assigneeDetails = "_mi-1";
export var assigneeInfo = "_mi-2";
export var dropdownContainer = "_mi-4";
export var dropdownImage = "_mi-5";
export var editAssigneeInfo = "_mi-3";
export var editAssigneeModalContainer = "_mi-6";
export var hidden = "_mi-8";
export var input = "_mi-7";